/* 🤖 this file was generated by svg-to-ts */
export {};
